module.exports = __webpack_public_path__ + "img/08_uk.1d2cd5cb.svg";